import { batchStart, batchEnd, batchScopeStart, batchScopeEnd, untrackStart, untrackEnd, } from './reaction';
import { createBoundaryAnnotation } from './internals';
export var action = createBoundaryAnnotation(function () {
    batchStart();
    untrackStart();
}, function () {
    untrackEnd();
    batchEnd();
});
action.scope = createBoundaryAnnotation(function () {
    batchScopeStart();
    untrackStart();
}, function () {
    untrackEnd();
    batchScopeEnd();
});
//# sourceMappingURL=action.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/reactive-vue/node_modules/@formily/reactive/esm/action.js
// module id = null
// module chunks = 